import type { ReactNode } from 'react';

export interface IconProps {
  size?: number;
  className?: string;
}

/**
 * 細線條圖示的外框：24×24 畫布、strokeWidth 1.5、顏色由 currentColor 繼承。
 *
 * 圖示是輔助內容，所以一律 `aria-hidden`，意思由旁邊的文字或按鈕的 `aria-label` 承擔。
 * app 專屬的圖示也用它包，才會與共用圖示同一個筆觸。
 */
export function Icon({
  size = 20,
  className,
  children,
}: IconProps & { children: ReactNode }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}
